import { ThemeProviderLocalized, getTheme } from '@lingoda/ui';
import * as muiLocales from '@lingoda/ui/theme/locale';
import { IconsProvider } from '@lingoda/ui/icons';

export const ThemeProvider = (props: { children: React.ReactNode }) => {
    const theme = getTheme();

    return (
        <ThemeProviderLocalized locales={muiLocales} theme={theme}>
            <IconsProvider>{props.children}</IconsProvider>
        </ThemeProviderLocalized>
    );
};
